// extracted by mini-css-extract-plugin
export default {"wpcardsContainer":"Offers-wpcardsContainer_JHgeB"};